"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var react_slick_1 = require("react-slick");
require("slick-carousel/slick/slick-theme.css");
require("slick-carousel/slick/slick.css");
require("./style/Screenshots.css");
var images = [
    require("../images/screenshots/tasks.png"),
    require("../images/screenshots/articles.png"),
    require("../images/screenshots/videos.png"),
    require("../images/screenshots/books.png"),
];
var mobileImages = [
    require("../images/screenshots/mobile_tasks.png"),
    require("../images/screenshots/mobile_menu.png"),
    require("../images/screenshots/mobile_articles.png"),
    require("../images/screenshots/mobile_trending.png"),
];
var Screenshots = /** @class */ (function (_super) {
    __extends(Screenshots, _super);
    function Screenshots() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Screenshots.prototype.render = function () {
        var isSmallWindow = this.props.isSmallWindow;
        return (React.createElement("div", { className: "Screenshots-container" },
            React.createElement("div", { className: "Screenshots-title" }, "Screenshots"),
            React.createElement(react_slick_1.default, { dots: true, adaptiveHeight: true, arrows: false, autoplay: true }, (isSmallWindow ? mobileImages : images).map(function (path) {
                // Image component is not available here somehow.
                return React.createElement("a", { key: path, href: path, target: "_blank" },
                    React.createElement("img", { className: "Screenshots-image", src: path }));
            }))));
    };
    return Screenshots;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var environment = _a.environment;
    return environment;
})(Screenshots);



//////////////////
// WEBPACK FOOTER
// ./src/component/Screenshots.tsx
// module id = 633
// module chunks = 0